import type { ApplicationState } from '@store/store';

export const selectApp = (state: ApplicationState) => state.app;

export const selectLocale = (state: ApplicationState) => selectApp(state).locale;
